import React, { Component } from "react";
import TypedText from "./TypedText";

class Home extends Component {
  render() {
    return (
      <article className="panel is-active" data-panel="home">
        <div className="home-inner">
          <p className="home-hello" data-en="Hello, I'm" data-fa="سلام، من">
            Hello, I&apos;m
          </p>
          <h2 className="home-name" data-en="Fatemeh Zare" data-fa="فاطمه زارع">
            Fatemeh Zare
          </h2>
          <p className="home-typed">
            <span className="typed-prefix " data-en="I'm a " data-fa="من یک ">
              I'm a
            </span>

            <TypedText
              language={this.props.language}
              texts={
                this.props.language === "fa"
                  ? ["توسعه‌دهنده خلاق هستم.", "خالق تجربه‌های ماندگار هستم.", "خالق تجربه‌های ماندگار هستم."]
                  : [
                      "Digital Product Builder.",
                      "Creative Developer.",
                      "Creator of Memorable Experiences.",
                    ]
              }
            />
          </p>
          <p
            className="home-lead"
            data-en="Crafting clean, minimal and memorable digital experiences that people love to use."
            data-fa="ایده‌ها را به تجربه‌های دیجیتالی تبدیل می‌کنم؛ تجربه‌هایی که زیبا، کاربردی و ماندگارند."
          >
            Turning ideas into digital experiences that are beautiful,
            functional, and memorable.
          </p>
          <div className="home-actions">
            <button
              className="btn-primary"
              onClick={() => this.props.onChangePanel("portfolio")}
              data-goto="portfolio"
              data-en="View Work"
              data-fa="نمونه‌کارها"
            >
              View Work
            </button>
            <button
              className="btn-ghost"
              onClick={() => this.props.onChangePanel("contact")}
              data-goto="contact"
              data-en="Contact Me"
              data-fa="تماس با من"
            >
              Contact Me
            </button>
          </div>
        </div>
      </article>
    );
  }
}

export default Home;
